import { REGION, regionAt, cursorFor, positionCloseAt, DRAG_CURSOR } from "./hitRegions";

const pickCursor = (press, region, drawingCursor) => {
  if (!press) return drawingCursor || cursorFor(region);
  return press.region === REGION.PANE ? DRAG_CURSOR : cursorFor(press.region);
};

/**
 * What the mouse shows while it moves over the chart: the crosshair over
 * the pane (also while panning) and the cursor of the region. Over the
 * close button of a position: the hand cursor, the hover state of the
 * button and its tooltip instead of the crosshair. Over a drawing: its cursor,
 * the crosshair stays.
 *
 * @param {HTMLElement} container
 * @param {object} overlay - crosshair overlay
 * @param {object} positions - positionsState
 * @param {object} drawings - createDrawings
 */
export const createHoverFeedback = (container, overlay, positions, drawings) => {
  let hoveredPositionId = null;

  // The highlight drops its own repeats; the tooltip is written only when it changes
  const setCloseHover = (positionId) => {
    const isOverClose = positionId !== null;

    positions.setHighlight(isOverClose ? { id: positionId, isPressed: false } : null);

    if (positionId === hoveredPositionId) return;

    hoveredPositionId = positionId;
    container.title = isOverClose ? positions.closeLabel : "";
  };

  return {
    /**
     * @param {{ x: number, y: number }} point - CSS px of the chart
     * @param {{ region: string, positionId: string|number|null } | null} press - the pressed pointer, if any
     */
    update: (point, press) => {
      const { layout } = overlay;

      if (!layout) return;

      const hoveredClose = press ? null : positionCloseAt(point, positions.closeButtons, false);
      const region = hoveredClose === null ? regionAt(point, layout) : REGION.POSITION_CLOSE;
      const isOverPane = region === REGION.PANE && (!press || press.region === REGION.PANE);

      // A pressed close button keeps its pressed state until it is released
      if (!press) setCloseHover(hoveredClose);

      const drawingCursor = press ? null : drawings.hover(region === REGION.PANE ? point : null, layout.pane);

      overlay.setPointer(isOverPane ? point : null);
      container.style.cursor = pickCursor(press, region, drawingCursor);
    },

    leave: () => {
      setCloseHover(null);
      overlay.setPointer(null);
    },

    destroy: () => {
      container.style.cursor = "";
      container.removeAttribute("title");
    },
  };
};
